/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourcesDuplicationRemoval extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourcesDuplicationRemoval");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourcesDuplicationRemoval.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourcesDuplicationRemoval>): BackgroundJobPayloadForResourcesDuplicationRemoval {
        let obj = Object.assign(new BackgroundJobPayloadForResourcesDuplicationRemoval(), model);
        BackgroundJobPayloadForResourcesDuplicationRemoval.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourcesDuplicationRemoval>): BackgroundJobPayloadForResourcesDuplicationRemoval {
        if (!model) return null;
        return BackgroundJobPayloadForResourcesDuplicationRemoval.newInstance(<BackgroundJobPayloadForResourcesDuplicationRemoval> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourcesDuplicationRemoval) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourcesDuplicationRemoval.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourcesDuplicationRemoval): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourcesDuplicationRemoval.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
